import { createFileRoute } from "@tanstack/react-router";

import { RequirePermission } from "@/hooks/shared/CheckAuth";
import { PayrollItemTypesPage } from "@/pages/dashboard/payroll-runs/items";

export const Route = createFileRoute("/_main/dashboard/payroll-runs/item-types")({
  component: () => (
    <RequirePermission action="payroll.read">
      <PayrollItemTypesPage />
    </RequirePermission>
  ),
});
